// @ts-nocheck
(function ($, talonUtil) {
    const serviceUrl = document.getElementById('serviceUrl').value;
    const detailsPageUrl = document.getElementById('detailsPageUrl').value;
    const resultsList = document.getElementById('product-comparison-results');
    const printButton = document.getElementById('button-print');
    if(printButton) {
        printButton.addEventListener('click', function() {
            document.body.classList.add('print');
            window.print();
        });
    }
    function addOdataParams(paramVal, filter) {
        const urlParams = new URLSearchParams(window.location.search);
        let paramName = 'ids';
        let paramsArray = [];
        if (urlParams.has(paramName) === true) {
            paramsArray = urlParams.get(paramName).split(',');
        }

        if (paramsArray.length > 0) {

            filter += paramVal;
            for (var i = 0; i < paramsArray.length; i++) {
                if (i > 0) {
                    filter += 'or ' + paramVal;
                }

                filter += ' eq ' + paramsArray[i] + ' ';
            }
        }

        return filter;
    }

    function generateOdataQuery() {

        var query = serviceUrl;

        var filter = "?$expand=parent($select=UrlName,Logos,Material,ColorOptionsCount,PanelDesignsCount,PriceRangeValue;$expand=RelatedWarranty($expand=Image),Logos,ColorSystems),ProductDistinctionsList&$filter="

        filter = addOdataParams('Id', filter);
        query += filter;
        return query;
    }

    function fetchItems() {
        var query = generateOdataQuery();
        fetch(query)
            .then((response) => {
                return response.json()
            })
            .then((data) => {
                renderResults(data);
            })
            .catch(error => {
                console.error('Error with comparison results', error);
            });
    }

    function renderResults(data) {
        resultsList.innerHTML = "";
        const results = data.value.map((item) => {
            const productDetailPage = (detailsPageUrl.lastIndexOf("/") === detailsPageUrl.length - 1)
                ? detailsPageUrl + item.Parent.UrlName
                : detailsPageUrl + "/" + item.Parent.UrlName;
            const productDistinction = item.ProductDistinctionsList.length > 0
                ? item.ProductDistinctionsList[0].Title
                : "";
            return `
                <li class="product-comparison__item">
                    ${
                        productDistinction
                        ?
                        `<span class="product-comparison__tag">${productDistinction}</span>`
                        : ''
                    }
                    <button type="button" aria-label="remove product" class="product-comparison__close" remove-product></button>
                    ${
                        item.ThumbnailUrl !== ""
                        ?
                        `<a href="${productDetailPage}" class="product-item__image-link" aria-label="view details about ${item.DisplayTitle}">
                            <img class="product-comparison__image" src="${item.ThumbnailUrl}" alt="${item.ThumbnailAltText}" />
                        </a>`
                        : ''
                    }
                    <div class="product-comparison__content">
                        <h3 class="product-comparison__title">
                        <a style="text-decoration: none; color: black;" href="${productDetailPage}">
                            ${item.DisplayTitle}
                            <span class="product-comparison__sub-title">${item.Model}</span>
                        </a>
                        </h3>
                        <table class="product-comparison__table">
                            ${item.Material
                                ?
                                `<tr>
                                    <td>Material Type:</td>
                                    <td>${item.Material}</td>
                                </tr>`
                                : ''
                            }
                            ${
                                item.NumberOfPanelDesigns
                                ?
                                `
                                <tr>
                                    <td>Number of Panel Designs:</td>
                                    <td>${item.NumberOfPanelDesigns}</td>
                                </tr>
                                `
                                : ''
                            }
                            ${
                                item.NumberOfColorOptions
                                ?
                                `<tr class="${item.NumberOfColorOptions === "0" && item.WoodOptionsCount === "0" ? "hidden-cell" : ""}">
                                    ${
                                        item.NumberOfColorOptions !== "0"
                                        ?
                                        `<td>Number of Color Options:</td>
                                        <td>${item.NumberOfColorOptions}</td>`
                                        : item.WoodOptionsCount !== "0"
                                        ?
                                        `<td>Number of Wood Options:</td>
                                        <td>${item.WoodOptionsCount}</td>`
                                        : '<td>Number of Wood/Color Options</td><td>0</td>'
                                    }
                                </tr>`
                                : ''
                            }
                            <tr>
                                <td>U-Factor:</td>
                                <td>${item.UFactor !== "" ? item.UFactor : "N/A"}</td>
                            </tr>
                            <tr>
                                <td class="product-comparison__r-value">R-Value:</td>
                                <td class="product-comparison__r-value">${item.RValue !== "" ? item.RValue : "N/A"}</td>
                            </tr>
                            <tr>
                                <td>Price:</td>
                                <td>${item.PriceRangeValue ? item.PriceRangeValue : "$"}</td>
                            </tr>
                        </table>
                        ${item.Parent.RelatedWarranty.map((warranty) => {
                            return `<div class="product-comparison__detail">
                                <div class="product-comparison__logo-wrapper gray-background">
                                    <img class="product-comparison__logo product-comparison__logo--secondary" src="${warranty.Image[0]?.Url}" alt="${warranty.Image[0]?.AlternativeText}">
                                </div>
                            </div>`
                        }).join('')}

                        <div class="product-comparison__logos ${item.Parent.Logos.length > 0 ? "active" : ""}">
                            ${item.Parent.Logos.map((logo) => {
                                return `<img src="${logo.Url}" alt="${logo.AlternativeText}" class="product-comparison__logo" />`
                            }).join('')}
                        </div>

                        ${item.Parent.ColorSystems.map((colorSystem) => {
                            return `<div class="product-comparison__detail product-comparison__detail--colors" data-section-colors>
                                ${colorSystem.Content}
                            </div>`
                        }).join('')}

                    </div>
                    <a href="${productDetailPage}" class="button button--yellow product-comparison__link" aria-label="view details about ${item.DisplayTitle}">View Details</a>
                </li>
            `
        }).join('');
        resultsList.insertAdjacentHTML('beforeend', results);
        registerRemoveItemClick();
        const colorSections = resultsList.querySelectorAll('[data-section-colors]');
        colorSections.forEach((section) => {
            keepImageElements(section);
        });
    };

    function registerRemoveItemClick() {
        const buttons = document.querySelectorAll('[remove-product]');
        buttons.forEach((item) => {
            item.addEventListener('click', function(e) {
                const target = e.target;
                const parentItem = target.parentElement;
                parentItem.style.display = 'none';
            })
        });
    }

    // remove all html from the colors section except image elements
    // adding data-attributes for specific elements to keep
    function keepImageElements(section) {
        const title = section.querySelector('[product-comparison-title]');
        const images = section.querySelectorAll('IMG');
        section.innerHTML = "";
        if (title) {
            // removing the asterisk
            const titleText = title.textContent;
            const hasAsterisk = titleText.indexOf('*') > - 1;
            if (hasAsterisk) {
                const titleTextParsed = title.textContent.substring(0, title.textContent.length - 1);
                title.textContent = titleTextParsed;
            }
            section.insertAdjacentElement('beforeend', title);
        }
        images.forEach((image) => {
            section.insertAdjacentElement("beforeend", image);
        });
    }

    fetchItems();

})(jQuery, window.talonUtil);
